<template>
  <b-modal id="folio-modal" :title="$t('menu.folio', 'Folio')" size="lg" ok-only>
    <template #modal-title>
      <div class="folio-modal-title">
        <span class="title-label">
          {{ $t('menu.folio', 'Folio') }}
        </span>
        <span class="title-meta">
          {{ $t('Purchased charts and services') }}
        </span>
      </div>
    </template>
    <b-tabs
        content-class="mt-3"
        nav-class="folio-tabs"
        active-nav-item-class="folio-tab-active"
    >
      <!-- Вкладка ENC S-63 (данные поставщика Primar - ячейки карт S63 ENC) -->
  <b-tab title="ENC S-63" title-link-class="folio-tab-link">
        <div v-if="s63Items.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedS63Items"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(id)="data">
                <div class="d-flex align-items-center">
                  <v-icon
                    v-if="data.item.isComplex"
                    name="hi-solid-cube"
                    scale="0.8"
                    class="mr-1 text-primary"
                    title="Composite Product"
                  />
                  <span>{{ data.value }}</span>
                </div>
              </template>
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft + ' days' }}
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.s63"
              :total-rows="s63Items.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No ENC S-63 data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка ENC S-102 (данные поставщика Primar - карты S102) -->
  <b-tab title="ENC S-102" title-link-class="folio-tab-link">
        <div v-if="s102Items.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedS102Items"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft + ' days' }}
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.s102"
              :total-rows="s102Items.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No ENC S-102 data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка AVCS S-63 (данные поставщика UKHO/MSS - ячейки карт AVCS) -->
      <!-- <b-tab title="AVCS S-63">
        <template v-if="avcsItems.length">
          <b-table size="sm" :items="avcsItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AVCS maps')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AVCS maps')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AVCS S-63 data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка ADP (данные поставщика UKHO/MSS - публикации ADP) -->
      <!-- <b-tab title="ADP">
        <template v-if="adpItems.length">
          <b-table size="sm" :items="adpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ADP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ADP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No ADP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка eNP (данные поставщика UKHO/MSS - публикации eNP) -->
      <!-- <b-tab title="eNP">
        <template v-if="enpItems.length">
          <b-table size="sm" :items="enpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ENP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ENP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No eNP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка Navarea (данные поставщика UKHO/MSS - навигационные предупреждения по районам) -->
  <b-tab title="Navarea" title-link-class="folio-tab-link">
        <div v-if="navareaItems.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedNavareaItems"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft + ' days' }}
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.navarea"
              :total-rows="navareaItems.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No Navarea data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка AIO (данные поставщика UKHO/MSS - данные Admirality Overlay Information) -->
      <!-- <b-tab title="AIO">
        <template v-if="aioItems.length">
          <b-table size="sm" :items="aioItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AIO')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AIO')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AIO data purchased</p>
          </div>
        </template>
      </b-tab> -->
        <div class="text-center mt-3">
      <b-link class="table-link" @click="goToFolio">
        Go to folio
      </b-link>
    </div>

    </b-tabs>
  </b-modal>
</template>

<script>
import { mapStores } from 'pinia'
import { useCatalogsStore } from '@/stores/catalogs'
import dayjs from 'dayjs'
import { prepareCatalog } from '@/helpers/api'

export default {
  props: {
    folio: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      folioFields: [
        { key: 'id', label: 'Item', tdClass: 'text-left', sortable: true },
        { key: 'period', label: 'Period', tdClass: 'text-left' },
        { key: 'paymentMethod', label: 'Payment Method', tdClass: 'text-left' },
        { key: 'createdUtc', label: 'Order Date', tdClass: 'text-left', sortable: true },
        { key: 'daysLeft', label: 'Days left', tdClass: 'text-left', sortable: true },
      ],
      perPage: 10,
      pagination: {
        s63: 1,
        s102: 1,
        navarea: 1,
        avcs: 1,
        adp: 1,
        enp: 1,
        aio: 1,
      },
    }
  },

  mounted() {
    this.ensureCatalogLoaded()
  },

  computed: {
    ...mapStores(useCatalogsStore),
    paginatedS63Items() {
      return this.paginate(this.s63Items, 's63')
    },

    paginatedS102Items() {
      return this.paginate(this.s102Items, 's102')
    },

    paginatedNavareaItems() {
      return this.paginate(this.navareaItems, 'navarea')
    },

    // Получение ячеек карт в формате S63 ENC от Primar
    s63Items() {
      return this.getUniqueItemsByType('s63 maps')
    },

    // Получение ячеек карт в формате S102 ENC
    s102Items() {
      return this.getUniqueItemsByType('s102 maps')
    },

    // Получение ячеек карт в формате AVCS от UKHO/MSS
    avcsItems() {
      return this.getUniqueItemsByType('AVCS maps')
    },

    // Получение публикаций ADP от UKHO/MSS
    adpItems() {
      return this.getUniqueItemsByType('ADP')
    },

    // Получение публикаций eNP от UKHO/MSS
    enpItems() {
      return this.getUniqueItemsByType('ENP')
    },

    // Получение данных Navarea (навигационные предупреждения по районам)
    navareaItems() {
      return this.getUniqueItemsByType('Navarea')
    },

    // Получение данных AIO (All In One)
    aioItems() {
      return this.getUniqueItemsByType('AIO')
    },
  },
  methods: {
    // Возвращает отфильтрованный массив с учетом пагинации
    paginate(items, key) {
      const totalPages = Math.max(1, Math.ceil(items.length / this.perPage))
      const current = this.pagination[key] || 1

      if (!this.pagination[key]) {
        this.$set(this.pagination, key, 1)
      }

      if (current > totalPages) {
        this.$set(this.pagination, key, totalPages)
      }

      const activePage = this.pagination[key] || 1
      const start = (activePage - 1) * this.perPage
      return items.slice(start, start + this.perPage)
    },

    async ensureCatalogLoaded() {
      if (!this.catalogsStore || !this.catalogsStore.getProducts || this.catalogsStore.getProducts.length === 0) {
        try {
          await prepareCatalog()
        } catch (e) {
          console.error('[FolioModal] Failed to load catalog', e)
        }
      }
    },

        // Переход к странице транзакций
    goToFolio() {
      this.$bvModal.hide('folio-modal');
      this.$router.push('/ship-folio');
    },

    // Получение уникальных элементов по типу с выбором последнего актуального заказа
    getUniqueItemsByType(itemType) {
      const map = new Map()
      
      // Группировка доступна для всех типов карт, если они есть в каталоге
      const cellToComplexProduct = new Map()
      
      if (this.catalogsStore && this.catalogsStore.getProducts) {
        this.catalogsStore.getProducts.forEach(p => {
          if (p.productCellList && p.productCellList.productCells && p.productCellList.productCells.length > 1) {
            p.productCellList.productCells.forEach(c => {
              cellToComplexProduct.set(c.id, p)
            })
          }
        })
      }

      const rawItems = []

      this.folio.forEach(order => {
        if (!order || !Array.isArray(order.items)) return

        order.items.forEach(item => {
          if (!item || item.type !== itemType || !item.id) return

          const monthCount = item.monthCount || 0
          const createdUtc = order.createdUtc || ''
          const paymentMethod = order.paymentMethod || '—'
          
          // Проверяем, являются ли это fallback данные (из primar-charts)
          const isFallback = order.id && order.id.startsWith('primar-charts-')
          
          rawItems.push({
            id: item.id,
            monthCount,
            createdUtc,
            paymentMethod,
            isFallback,
            orderId: order.id,
            expireAt: item.expireAt
          })
        })
      })

      // 2. Группируем ячейки по продуктам
      const groupedCellIds = new Set()
      const productSummary = new Map() // productId -> { id, period, daysLeft, ... }

      rawItems.forEach(item => {
        const parentProduct = cellToComplexProduct.get(item.id)
        if (parentProduct) {
          if (!productSummary.has(parentProduct.id)) {
            productSummary.set(parentProduct.id, {
              id: parentProduct.id,
              isComplex: true,
              items: []
            })
          }
          productSummary.get(parentProduct.id).items.push(item)
          groupedCellIds.add(item.id)
        }
      })

      // 3. Обрабатываем результаты
      const processItem = (id, items, isComplex = false) => {
        // Ищем самый свежий/лучший статус среди всех записей для этого ID
        let bestCandidate = null

        items.forEach(item => {
          const { createdUtc, monthCount, isFallback, paymentMethod, expireAt } = item
          
          let daysLeft
          let expiryDateRaw = null

          if (isFallback) {
            const finalExpiryDate = expireAt || createdUtc
            const endDate = new Date(finalExpiryDate)
            if (!Number.isNaN(endDate.getTime())) {
              expiryDateRaw = finalExpiryDate
              // Используем dayjs для консистентного расчета (с округлением до начала дня)
              const end = dayjs(finalExpiryDate).startOf('day')
              const now = dayjs().startOf('day')
              daysLeft = end.diff(now, 'day')
              daysLeft = daysLeft > 0 ? daysLeft : 0
            } else {
              daysLeft = 0
            }
          } else {
            daysLeft = this.calculateDaysLeft(createdUtc, monthCount)
            if (createdUtc && !Number.isNaN(new Date(createdUtc).getTime())) {
              const d = new Date(createdUtc)
              d.setMonth(d.getMonth() + monthCount)
              expiryDateRaw = d.toISOString()
            }
          }
          
          let daysLeftClass = isFallback 
            ? this.getDaysLeftClassForExpiryDate(expireAt || createdUtc)
            : this.getDaysLeftClass(createdUtc, monthCount)

          if (!daysLeftClass) {
            daysLeftClass = daysLeft > 0 ? 'days-good' : 'days-critical'
          }

          const candidate = {
            id: id,
            isComplex,
            period: (isFallback || isComplex) ? '—' : this.formatPeriod(monthCount),
            paymentMethod: (isFallback || isComplex) ? '—' : paymentMethod,
            createdUtc: (isFallback || isComplex) ? null : createdUtc,
            daysLeft,
            daysLeftClass,
            _expiryDateRaw: expiryDateRaw,
            _createdUtcRaw: createdUtc
          }

          if (!bestCandidate 
            || candidate.daysLeft > bestCandidate.daysLeft
            || (candidate.daysLeft === bestCandidate.daysLeft && this.isFresher(candidate._createdUtcRaw, bestCandidate._createdUtcRaw))
          ) {
            bestCandidate = candidate
          }
        })

        if (bestCandidate) {
          map.set(id, bestCandidate)
        }
      }

      // Добавляем продукты
      productSummary.forEach((info, productId) => {
        processItem(productId, info.items, true)
      })

      // Добавляем оставшиеся ячейки
      rawItems.forEach(item => {
        if (!groupedCellIds.has(item.id)) {
          processItem(item.id, [item], false)
        }
      })

      return Array.from(map.values()).sort((a, b) => {
        if (b.daysLeft !== a.daysLeft) {
          return b.daysLeft - a.daysLeft
        }

        const aTime = a._createdUtcRaw ? new Date(a._createdUtcRaw).getTime() : 0
        const bTime = b._createdUtcRaw ? new Date(b._createdUtcRaw).getTime() : 0

        if (bTime !== aTime) {
          return bTime - aTime
        }

        return (a.id || '').localeCompare(b.id || '')
      })
    },

    isFresher(candidateDate, existingDate) {
      const c = candidateDate ? new Date(candidateDate).getTime() : null
      const e = existingDate ? new Date(existingDate).getTime() : null
      if (c === null) return false
      if (e === null) return true
      return c > e
    },

    // Фильтрация элементов по типу (используется в закомментированных секциях)
    getFilteredItems(items, itemType) {
      if (!Array.isArray(items)) return []
      return items.filter(item => item && item.type === itemType)
    },

    // Форматирование периода действия
    formatPeriod(monthCount) {
      if (!monthCount || monthCount <= 0) return '—'
      const suffix = monthCount === 1 ? 'month' : 'months'
      return `${monthCount} ${suffix}`
    },

    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return '—'
      const date = new Date(dateString)
      if (Number.isNaN(date.getTime())) return '—'
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    // Расчет оставшихся дней до окончания действия подписки
    calculateDaysLeft(startDate, monthCount) {
      if (!startDate) return 0

      // Используем dayjs для аналогичного расчета как в FolioTable.vue
      // Используем startOf('day') для корректного подсчета полных дней
      const end = dayjs(startDate).add(monthCount, 'month').startOf('day')
      const now = dayjs().startOf('day')
      const diff = end.diff(now, 'day')

      return diff > 0 ? diff : 0
    },

    // Получение CSS класса для отображения оставшихся дней
    getDaysLeftClass(startDate, monthCount) {
      if (!startDate) return 'days-critical'

      const start = new Date(startDate)
      if (Number.isNaN(start.getTime())) return 'days-critical'

      const daysLeft = this.calculateDaysLeft(startDate, monthCount)

      if (daysLeft < 1) return 'days-critical'
      if (daysLeft <= 30) return 'days-warning'
      return 'days-good'
    },

    // Получение CSS класса для отображения оставшихся дней (для даты окончания в fallback)
    getDaysLeftClassForExpiryDate(expiryDate) {
      if (!expiryDate) return 'days-critical'

      // Используем dayjs для консистентности
      const expiry = dayjs(expiryDate).startOf('day')
      const now = dayjs().startOf('day')
      const daysLeft = expiry.diff(now, 'day')

      if (daysLeft < 1) return 'days-critical'
      if (daysLeft <= 30) return 'days-warning'
      return 'days-good'
    },

  },
}
</script>

<style scoped>
.modal-section {
  border: 1px solid #e4e8f5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #fbfcff 0%, #f6f8ff 100%);
  box-shadow: 0 4px 16px rgba(34, 45, 80, 0.07);
}

.styled-table >>> thead tr {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.72rem;
  color: #5c6685;
  background: #eef1fb;
}

.styled-table >>> tbody tr {
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.styled-table >>> tbody tr:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.09);
  background: #ffffff;
}

.styled-table >>> td {
  vertical-align: top;
  padding: 0.7rem;
  border-top: none;
  border-bottom: 1px solid #eef1fb;
  color: #1f2940;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.35;
}

.tab-content {
  display: flex;
  flex-direction: column;
}

.styled-pagination >>> .page-link {
  border-radius: 999px !important;
  margin: 0 4px;
  padding: 6px 12px;
  border: 1px solid rgba(98, 111, 149, 0.25);
  background: rgba(255, 255, 255, 0.95);
  color: #1f2940;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(20, 29, 56, 0.08);
}

.styled-pagination >>> .page-item.active .page-link {
  background: linear-gradient(135deg, #f4f6ff, #e9edff);
  color: #2f3760;
  border-color: rgba(98, 111, 149, 0.35);
  box-shadow: 0 6px 14px rgba(31, 41, 64, 0.16);
}

.styled-pagination >>> .page-link:hover {
  color: #151b2c;
  box-shadow: 0 4px 10px rgba(31, 41, 64, 0.12);
}

.styled-pagination >>> .page-item.disabled .page-link {
  opacity: 0.5;
  box-shadow: none;
}

.days-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  margin-top: 2px;
  text-transform: uppercase;
  box-shadow: inset 0 0 0 1px rgba(98, 111, 149, 0.12);
}

.days-good {
  background-color: #e3f5ea;
  color: #1f7a4d;
}

.days-warning {
  background-color: #fff4df;
  color: #a76200;
}

.days-critical {
  background-color: #ffe5e9;
  color: #a90021;
}

.empty-state {
  border: 1px dashed #cdd3e5;
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  background: #f8f9fe;
  color: #5c6685;
}

.folio-tabs >>> .nav-link,
.folio-tabs >>> .nav-link > span,
.folio-tabs >>> .folio-tab-link {
  border-radius: 999px;
  margin-right: 12px;
  padding: 0.5rem 1.25rem;
  color: #5c6685;
  transition: background-color 0.15s ease, color 0.15s ease;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
}

.folio-tab-link {
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
  color: #5c6685 !important;
}

.folio-tab-link.active,
.folio-tab-link.folio-tab-active {
  color: #ffffff !important;
}

.folio-tabs >>> .nav-link:hover,
.folio-tabs >>> .nav-link:hover > span,
.folio-tabs >>> .folio-tab-link:hover {
  background: #eef1fb;
  color: #1f2940;
}

.folio-tab-active >>> .nav-link,
.folio-tab-active >>> .folio-tab-link {
  background: #4b5fdd !important;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(75, 95, 221, 0.25);
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
}

.folio-tab-active >>> .nav-link > span,
.folio-tab-active >>> .folio-tab-link > span {
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
  color: #ffffff !important;
}

.folio-modal-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.folio-modal-title .title-label {
  color: #1f2940;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.folio-modal-title .title-meta {
  color: #5b6480;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.table-link {
  font-weight: 500;
  color: #3a4256;
  border-bottom: 1px dashed rgba(37, 45, 64, 0.65);
  padding-bottom: 1px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.table-link:hover {
  color: #161b28;
}

::v-deep #folio-modal .modal-header {
  background: linear-gradient(135deg, #f4f6ff 0%, #e6e9ff 100%);
  border-bottom: none;
  padding: 18px 22px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 -1px 0 rgba(98, 111, 149, 0.12);
}

::v-deep #folio-modal .modal-header .close {
  color: #4b5fdd;
  opacity: 0.75;
  text-shadow: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

::v-deep #folio-modal .modal-header .close:hover {
  opacity: 1;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .modal-section {
    padding: 12px;
  }

  .styled-table >>> td {
    padding: 0.6rem;
  }
}
</style>
